import {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import FormItem from "../../../components/Form/FormItem/FormItem";
import FormButton from "../../../components/Form/Button/FormButton";
import GoogleButton from "../../../components/Buttons/GoogleButton/GoogleButton";
import {toast} from "react-toastify";
import FormNoneFieldErrors from "../../../components/Form/FormNoneFieldErrors";
import {useSession} from "../../../redux/Reducers/AuthReducer";
import axiosInstance, {axiosInstanceUnAuthorized} from "../../../API/Axios/AxiosConfig";
import URLS from "../../../API/Axios/URLS";
import {HTTP_400_BAD_REQUEST, is_success} from "../../../API/Axios/Status";
import LOGO from "../../../assets/img/logo/logo.png"
import Icon from "../../../components/Icon/Icon";

export default function SignUp({className, ...props}) {
    const [error, setError] = useState({});
    const [form, setForm] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        full_name: "",

    });
    const [loading, setLoading] = useState(false);
    const {authActions} = useSession();
    const navigate = useNavigate();

    function validatePassword() {
        if (form.password !== form.confirmPassword || form.password.length === 0) {
            setError({
                confirmPassword: ["Password and Confirm Password not match"]
            })
            return false;
        }
        return true;

    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validatePassword()) return;
        setLoading(true);
        setError({})

        axiosInstanceUnAuthorized.post(URLS.signUp, form).then((res) => {
            if (is_success(res?.status)) {
                toast("Account created", {
                    type: "success"
                });

                navigate("/auth/login")
            }
            setLoading(false);
        }).catch((err) => {
            toast("Validation error", {
                type: "error"
            })
            if (err?.response?.status === HTTP_400_BAD_REQUEST) {
                setError(err?.response?.data);
            } else {
                setError({
                    non_field_errors: ["Something went wrong, please try again later."]
                })
            }

        }).finally(() => setLoading(false))


    }


    return (
        <form onSubmit={handleSubmit}
              className=" w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[480px]">

            <div className={"w-full flex mb-5   justify-center items-center"}>
                <img src={LOGO} className={"w-[200px] h-auto"} alt={"DetStudy"}/>

            </div>
            <h4 className="mb-2.5 text-4xl text-center font-bold text-navy-700 dark:text-white">
                Sign Up
            </h4>
            <GoogleButton className={"my-4"}/>

            <div className={"flex flex-row  mb-4 justify-center items-center gap-2 text-sm text-gray-400"}>
                <div className={"line flex-1"}/>
                OR
                <div className={"line flex-1"}/>
            </div>

            <FormItem
                LeftIcon={<Icon src={"/icons/person.svg"} className={"w-5 h-5"}/>}

                type={"error"}
                className={"mb-2"}
                message={error?.full_name}
                variant={"auth"}
            >
                <input
                    type="text"
                    name="full_name"
                    id="email"
                    value={form.full_name}
                    onChange={(e) => {
                        setForm({
                            ...form,
                            full_name: e.target.value
                        })
                    }}
                    required
                    placeholder="Full Name"
                />


            </FormItem>
            <FormItem
                LeftIcon={<Icon src={"/icons/email.svg"} className={"w-5 h-5"}/>}

                type={"error"}
                className={"mb-2"}
                message={error?.email}
                variant={"auth"}
            >
                <input
                    type="email"
                    name="email"
                    id="email"
                    value={form.email}
                    onChange={(e) => {
                        setForm({
                            ...form,
                            email: e.target.value
                        })
                    }}
                    required
                    placeholder="Email"
                />


            </FormItem>

            <FormItem
                LeftIcon={<Icon src={"/icons/lock.svg"} className={"w-5 h-5"}/>}

                type={"error"}
                message={error?.password}
                variant={"auth"}
            >
                <input
                    type="password"
                    name="password"
                    id="password"
                    value={form.password}
                    onChange={(e) => {
                        setForm({
                            ...form,
                            password: e.target.value
                        })
                    }}
                    required
                    placeholder="password"
                />


            </FormItem>
            <FormItem
                LeftIcon={<Icon src={"/icons/lock.svg"} className={"w-5 h-5"}/>}

                type={"error"}
                message={error?.confirmPassword}
                variant={"auth"}
            >
                <input
                    type="password"
                    name="password"
                    id="password"
                    value={form.confirmPassword}
                    onChange={(e) => {
                        setForm({
                            ...form,
                            confirmPassword: e.target.value
                        })
                    }}
                    required
                    placeholder="confirm password"
                />


            </FormItem>

            <FormNoneFieldErrors errors={error?.non_field_errors} className={"mb-4 mt-2"}/>


            <FormButton
                loading={loading}
                type={"submit"}
            >
                Sign Up
            </FormButton>
            <div className="mt-4">
            <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
                    Already have an account?
            </span>
                <Link
                    to={"/auth/login"}

                    className="ml-1 text-sm cursor-pointer font-medium text-tertiary-900 hover:text-tertiary-800 dark:text-white"
                >
                    Sign In
                </Link>
            </div>
        </form>

    )
}